/* eslint-disable no-eval */
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import './addItem.scss'

class AddItem extends Component {

    render() {
        return (           
            <div className="addItem">
               <Button variant="outlined" startIcon={ <Icon>add</Icon>} onClick={this.props.action}>              
                    {this.props.text}
                </Button>
            </div>
        );
    }
}

export default AddItem